import type { ReactNode } from 'react';
import { Button } from 'components/ui/button';

export const incidentStatusLabels = {
  open: 'Åben',
  acknowledged: 'Set',
  in_progress: 'Under behandling',
  resolved: 'Løst',
};

export function alertDate(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(value)) return 'Ikke registreret';
  return new Intl.DateTimeFormat('da-DK', {
    dateStyle: 'medium',
    timeStyle: 'short',
    timeZone: 'Europe/Copenhagen',
  }).format(value);
}

export function ErrorNotice({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  if (!error) return null;
  return (
    <div className="ua-notice ua-error" role="alert">
      <span>{error instanceof Error ? error.message : String(error)}</span>
      {onRetry && (
        <Button type="button" variant="outline" size="sm" onClick={onRetry}>
          Prøv igen
        </Button>
      )}
    </div>
  );
}

export function Field({
  label,
  children,
  hint,
}: {
  label: string;
  children: ReactNode;
  hint?: string;
}) {
  return (
    <label className="ua-field">
      <span>{label}</span>
      {children}
      {hint && <small>{hint}</small>}
    </label>
  );
}

export function LoadingNotice({ children = 'Henter alarmer…' }: { children?: ReactNode }) {
  return (
    <p role="status" className="ua-muted ua-loading">
      {children}
    </p>
  );
}
